/**
 * Leep Chás — GSAP scroll animations + hero (homepage)
 */
(function () {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initScrollAnimations = () => {
    if (reduced || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      document.querySelectorAll('[data-animate="fade-up"]').forEach((el) => {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray('[data-animate="fade-up"]').forEach((el) => {
      gsap.from(el, {
        y: 48,
        opacity: 0,
        scale: 0.98,
        duration: 0.9,
        ease: 'expo.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        },
      });
    });
  };

  const initHero = () => {
    const hero = document.querySelector('[data-hero-content]');
    if (!hero || reduced || typeof gsap === 'undefined') return;

    const items = hero.querySelectorAll('[data-hero-item]');
    gsap.from(items, {
      y: 40,
      opacity: 0,
      duration: 1,
      stagger: 0.12,
      ease: 'expo.out',
      delay: 0.1,
    });

    const visual = document.querySelector('[data-hero-visual]');
    const image = visual?.querySelector('.hero__image, .hero__image-placeholder');
    if (!image) return;

    gsap.from(image, {
      y: 30,
      opacity: 0,
      scale: 0.92,
      duration: 1.2,
      ease: 'expo.out',
      delay: 0.35,
    });

    if (window.matchMedia('(pointer: fine)').matches) {
      visual.addEventListener('mousemove', (event) => {
        const rect = visual.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        gsap.to(image, {
          rotateY: x * 12,
          rotateX: -y * 8,
          duration: 0.4,
          ease: 'power2.out',
        });
      });
      visual.addEventListener('mouseleave', () => {
        gsap.to(image, { rotateY: 0, rotateX: 0, duration: 0.6, ease: 'expo.out' });
      });
    }
  };

  const boot = () => {
    document.documentElement.classList.add('gsap-ready');
    initScrollAnimations();
    if (document.body.classList.contains('template-index')) {
      initHero();
    }
  };

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    boot();
  } else {
    window.addEventListener('load', () => {
      document.documentElement.classList.add('gsap-ready');
      document.querySelectorAll('[data-animate="fade-up"]').forEach((el) => {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
    }, { once: true });
  }
})();
